import React from "react";

interface Props {
  className?: string;
}

const KeyIcon = (props: Props) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="64" height="64" rx="32" fill="#2979FF" />
    <path
      d="M32.65 30C31.83 27.67 29.61 26 27 26C23.69 26 21 28.69 21 32C21 35.31 23.69 38 27 38C29.61 38 31.83 36.33 32.65 34H37V38H41V34H43V30H32.65ZM27 34C25.9 34 25 33.1 25 32C25 30.9 25.9 30 27 30C28.1 30 29 30.9 29 32C29 33.1 28.1 34 27 34Z"
      fill="white"
      className={props.className}
    />
  </svg>
);
KeyIcon.defaultProps = {
  className: undefined,
};

export default KeyIcon;
